import React, { useEffect } from 'react';
import { Button, message, Flex, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useLazyMergeMaterialCertificatesQuery, } from '../../redux/api/order-line-item';

const { Text } = Typography;

interface ButtonProps {
	lineItemId: string;
	isDisabled?: boolean;
	fileName?: string;
}

export const MaterialCertificatesButton: React.FC<
	ButtonProps
> = ({ lineItemId, isDisabled, fileName }) => {
	const [messageApi, contextHolder] = message.useMessage();

	const [
		triggerReport,
		{ data: data, error: error, isLoading: isLoading },
	] = useLazyMergeMaterialCertificatesQuery();

	useEffect(() => {
		if (data) {
			const url = URL.createObjectURL(data);

			const fallbackName = `Certs_${lineItemId}.pdf`;
			const composedName = fileName && fileName.trim() !== '' ? fileName : fallbackName;

			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', composedName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			setTimeout(() => URL.revokeObjectURL(url), 1000);
		}
	}, [data, fileName, lineItemId]);

	useEffect(() => {
		if (error) {
			console.error('Error getting material certificates:', error);
			messageApi.error('Failed to get material certificates');
		}
	}, [error, messageApi]);

	const handleDownloadReport = async () => {
		try {
			await triggerReport(lineItemId).unwrap();
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<>
			{contextHolder}
			<Flex vertical align="start">
				<Text>Material Certificates</Text>
				<Button
					icon={<DownloadOutlined />}
					type="primary"
					onClick={handleDownloadReport}
					loading={isLoading}
					disabled={isDisabled}
					
				>
					{isLoading ? 'Generating...' : 'Download'}
				</Button>
				{error && (
					<Text type="danger" style={{ marginTop: 4 }}>
						Error generating report
					</Text>
				)}
			</Flex>
		</>
	);
};
